/**
 * WordPress dependencies
 */
export * from '@wordpress/commands';
